import Head from "next/head";
import Footer from "pages/components/Footer";
import StartHumming from "pages/components/StartHumming";
import Topbar from "pages/components/Topbar";
import React, { useLayoutEffect } from "react";
import { ExtendedNextPage } from "types/pages";

import axios from "axios";
import useAsyncState from "hooks/use-async-state";
import Benefits from "./components/Benefits";
import Heading from "./components/Heading";
import JoinUs from "./components/JoinUs";
import OurInvestors from "./components/OurInvestors";
import OurMission from "./components/OurMisson";

import styles from "./styles.module.scss";
import { formatJobData } from "./components/JoinUs/utils";
import { Opening } from "./components/JoinUs/types";

type Props = {
  openings: Opening[];
};

const About: ExtendedNextPage<Props> = () => {
  const {
    data: openings,
    refresh,
    inProgress
  } = useAsyncState([], async () => {
    const { data: greenhouseData } = await axios.get(
      "https://boards-api.greenhouse.io/v1/boards/humminghomes/jobs?content=true"
    );

    return formatJobData(greenhouseData);
  });

  useLayoutEffect(() => {
    refresh();
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>About page</title>
        <meta name="about" content="Humming home's about page" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Heading />
      <OurInvestors />
      <OurMission />
      <Benefits />
      <JoinUs loading={inProgress} openings={openings} />
      <StartHumming fillColor="primary" />
    </div>
  );
};

About.getLayout = (page) => {
  return (
    <div>
      <Topbar withHeader />
      {page}
      <Footer />
    </div>
  );
};

export default About;
